import { render, staticRenderFns } from "./DishManagement.vue?vue&type=template&id=8405208a"
import script from "./DishManagement.vue?vue&type=script&lang=ts"
export * from "./DishManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports